import './about.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function About() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(Boolean(token));
  }, []);

  return (
    <div className="about-page">
      <div className="about-hero">
        <p className="eyebrow">About Us</p>
        <h1>Predict. Play. Celebrate Cricket.</h1>
        <p className="subhead">
          We built Cricket Prediction to blend live action, sharp analytics, and a community of fans who love calling the game.
        </p>
        <div className="hero-stats">
          <div className="stat">
            <span className="stat-number">24/7</span>
            <span className="stat-label">Live Coverage</span>
          </div>
          <div className="stat">
            <span className="stat-number">10K+</span>
            <span className="stat-label">Predictions</span>
          </div>
          <div className="stat">
            <span className="stat-number">Global</span>
            <span className="stat-label">Fan Base</span>
          </div>
        </div>
      </div>

      <div className="about-grid">
        <section className="panel">
          <h2>Why We Exist</h2>
          <p>
            Cricket is more than a sport—it’s a pulse. We wanted a place where every over, every session, and every hunch could be shared, tracked, and celebrated. Our platform brings live data, prediction tools, and community energy into one experience.
          </p>
        </section>

        <section className="panel">
          <h2>How It Works</h2>
          <ul>
            <li><strong>Live Matches:</strong> Track real-time scores, odds, and key moments.</li>
            <li><strong>Smart Predictions:</strong> Make calls on winners and sessions with instant feedback.</li>
            <li><strong>Community Vibes:</strong> Compare your reads with fellow fans and climb the leaderboard.</li>
          </ul>
        </section>

        <section className="panel highlight">
          <h2>Our Promise</h2>
          <p>
            Simple, fast, and fun. We’re obsessed with delivering clean design, accurate data, and a smooth journey—so you can focus on the thrill of the game.
          </p>
        </section>
      </div>

      <div className="values">
        <div className="value-card">
          <h3>AI-estimated session runs</h3>
          <p>Accurate projections on likely runs each session, tuned to live dynamics and conditions.</p>
        </div>
        <div className="value-card">
          <h3>Probable match outcomes</h3>
          <p>Momentum shifts, player impact, and statistical patterns combined to show each team’s winning chances.</p>
        </div>
        <div className="value-card">
          <h3>In-depth cricket insights</h3>
          <p>Trends on run-rate pressure, boundary %, strike rotation, and more to deepen your match IQ.</p>
        </div>
      </div>

      <div className="notice">
        <h3>⚠ No Betting — Only Analytics</h3>
        <p>We do not support betting or gambling. Predictions are for informational and analytical purposes—built to enhance your cricket knowledge and enjoyment.</p>
      </div>

      <div className="values mission">
        <div className="value-card">
          <h3>🎯 Our Mission</h3>
          <p>To empower cricket fans with smart, transparent, and data-driven insights that make every match more engaging and understandable.</p>
        </div>
        <div className="value-card">
          <h3>🌟 Why Choose Us?</h3>
          <ul>
            <li>AI-powered predictions</li>
            <li>Real-time updates</li>
            <li>Transparent analytics</li>
            <li>Easy-to-understand insights</li>
            <li>100% safe, non-betting platform</li>
          </ul>
        </div>
      </div>

      <div className="cta">
        <h2>Ready to call the next big upset?</h2>
        <p>Join the community, make your predictions, and celebrate every boundary together.</p>
        <button
          className="cta-button"
          onClick={() => navigate(isLoggedIn ? '/match' : '/register')}
        >
          Get Started
        </button>
      </div>
    </div>
  );
}
